import { apiFetch } from '@ami/react/core';
import ThumbBucketLocationType from './entities/thumbBucketLocationType';
import BucketBrandType from './entities/bucketBrandType';
const { AbortController } = window;

const _baseEndPoint = 'sales/quote-product/lead-time';
let controller = null;

export default {
  calculateLeadTime: async (input) => {
    if (controller) {
      controller.abort();
    }

     controller = new AbortController();
      const signal = controller.signal;
      var model = null;
      const quoteProductLeadTimeInput = new QuoteProductLeadTimeInput(input);

      await apiFetch(`${_baseEndPoint}`, 'POST', quoteProductLeadTimeInput, {
        automaticSuccessNotification: false
      }, false, {signal: signal} ).then(
        (response) => (model =new QuoteProductLeadTimeOutput(response))
      ).catch(() => {});
      return model;
    },
};

export class QuoteProductLeadTimeInput {
  constructor(item) {
    if (item) {
      this.productId = item.productId;
      this.productGroupId = item.productGroupId;
      this.inventoryItemId = item.inventoryItemId;
      this.productOptionIds = item.productOptionIds;
      this.weightCategoryId = item.weightCategoryId;
      this.machineId = item.machineId;
      this.attachmentPoint = item.attachmentPoint;
      this.carrierId = item.carrierId;

      //TODO: we should post the detail object and let the api decide isThumbForNonAmiBucket
      //having issues with deserialization of QuoteProductDetailInput and null properties
      const detail = item.productDetail;
      const isAmiBucket = !!detail && (detail.bucketLocation === ThumbBucketLocationType.SameQuote || detail.bucketLocation === ThumbBucketLocationType.ExistingQuote && detail.existingBucket && detail.existingBucket.brand === BucketBrandType.ami.id);

      this.isThumbForNonAmiBucket = !!detail && isAmiBucket === false;
    }
  }
}

export class QuoteProductLeadTimeOutput {
  constructor(item) {
    if (item) {
      this.totalLeadTimeInDays = item.totalLeadTimeInDays;
      this.availableOn = item.availableOn;
      this.product =  new LeadTimeComponentOutput(item.product)
      this.productOptions = item.productOptions.map(x => new LeadTimeComponentOutput(x));
      this.state = item.state;
      this.eligibleForFastTrack = item.eligibleForFastTrack;
      this.isFastTrack = item.isFastTrack;
      this.isLuggingOnlyFastTrack = item.isLuggingOnlyFastTrack;
    }
  }
}

export class LeadTimeComponentOutput {
  constructor(item) {
    if (item) {
      this.correlationId = item.correlationId;
      this.subComponents = item.subComponents.map(x => new LeadTimeSubComponentOutput(x));
      this.details = item.details;
      this.showDetails = false;
    }
  }
}

export class LeadTimeSubComponentOutput {
  constructor(item) {
    if (item) {
      this.key = item.key;
      this.name = item.name;
      this.value = item.value;
      this.isOverridden = item.isOverridden;
      this.overrideValue = item.overrideValue;
      this.overrideAvailableOn = item.overrideAvailableOn;
      this.unit = item.unit;
      this.availableOn = item.availableOn;
    }
  }
}

export const LeadTimeUnit = Object.freeze({
  Hours: 'Hours',
  Days: 'Days',
});
